var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuetify-wrapper" }, [
    _c(
      "div",
      { staticClass: "v-application v-application--is-ltr" },
      [
        _c(
          "v-card",
          [
            _c(
              "v-card",
              {
                staticClass: "rounded-lg mx-5 mt-3 v-application",
                attrs: { outlined: "", elevation: "0" },
              },
              [
                _c("v-card-title", [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-wrap align-baseline" },
                    [
                      _vm.phone
                        ? _c("span", { staticClass: "ml-5 body-1" }, [
                            _c("span", { staticClass: "h4" }, [
                              _vm._v("Telefon: "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: { href: `tel:${_vm.phone}` },
                                on: { click: _vm.addCallHistory },
                              },
                              [_vm._v(_vm._s(_vm.phone))]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mobile
                        ? _c("span", { staticClass: "ml-4" }, [
                            _c("span", { staticClass: "h4" }, [
                              _vm._v("Mobile: "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: { href: `tel:${_vm.mobile}` },
                                on: { click: _vm.addCallHistory },
                              },
                              [_vm._v(_vm._s(_vm.mobile))]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "ml-10" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "capture-call-btn",
                              attrs: {
                                small: "",
                                outlined: "",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.isConfirmationDialogOpen = true
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-2", attrs: { small: "" } },
                                [_vm._v("mdi-phone")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Call Erfassen")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("ConfirmationDialog", {
              attrs: { message: "Call Erfassen?" },
              on: { save: _vm.addCallHistory },
              model: {
                value: _vm.isConfirmationDialogOpen,
                callback: function ($$v) {
                  _vm.isConfirmationDialogOpen = $$v
                },
                expression: "isConfirmationDialogOpen",
              },
            }),
            _vm._v(" "),
            _c("v-data-table", {
              staticClass: "elevation-1 v-application--is-ltr",
              attrs: {
                headers: _vm.historyHeaders,
                items: _vm.callHistory,
                "items-per-page": 25,
                "no-data-text": "Keine Apotheken in dieser Kategorie",
                options: _vm.tableOptions,
                loading: _vm.isLoading,
                "loading-text": "Wird geladen...",
                "disable-filtering": "",
                "footer-props": {
                  "items-per-page-options": [25, 50, 100],
                  "show-first-last-page": true,
                  "items-per-page-text": "Zeilen pro Seite",
                },
              },
              on: {
                "update:options": [
                  function ($event) {
                    _vm.tableOptions = $event
                  },
                  _vm.onOptionsChange,
                ],
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function ({ item }) {
                    return [
                      _c("tr", { attrs: { "data-call-id": item.call_id } }, [
                        _c("td", [
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "text-decoration-none",
                                attrs: {
                                  href: `/pharmacists/${item.user_id}`,
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(item.caller_user.firstname) +
                                    " " +
                                    _vm._s(item.caller_user.lastname) +
                                    "\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c("small", [
                                _vm._v(_vm._s(item.caller_user.email)),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.formatDate(item.date)))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("v-simple-checkbox", {
                              attrs: { value: item.is_successful },
                              on: {
                                click: function ($event) {
                                  return _vm.updateCallHistory(item)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }